import { DEFAULT_VAPI_AGENT_ID } from '../../../constants/voiceDefaults';

export { DEFAULT_VAPI_AGENT_ID };

export const VOICE_OPTIONS = [
  {
    id: 'anna-dutch',
    vapiAgentId: '74af3b57-be80-438f-ab56-8e07161b3e62',
    name: 'Anna',
    languageKey: 'dutch',
    genderKey: 'female',
    sampleUrl: '/assets/voices/voice_anna.m4a',
  },
  {
    id: 'peter-dutch',
    vapiAgentId: '25dba09d-9e8d-4f99-b056-888f4bf0a708',
    name: 'Peter',
    languageKey: 'dutch',
    genderKey: 'male',
    sampleUrl: '/assets/voices/voice_peter.m4a',
  },
  {
    id: 'julia-dutch',
    vapiAgentId: 'a53e748a-32e1-4769-b845-e1885924c116',
    name: 'Julia',
    languageKey: 'dutch',
    genderKey: 'female',
    sampleUrl: '/assets/voices/voice_julia.m4a',
  },
  {
    id: 'sofia-english',
    vapiAgentId: 'c070d9ca-256d-454f-bc53-8219cdec7781',
    name: 'Sofia',
    languageKey: 'english',
    genderKey: 'female',
    sampleUrl: '/assets/voices/voice_sofia.m4a',
  },
  {
    id: 'john-english',
    vapiAgentId: 'a7854bf6-77b5-471e-9174-6b147a3069dd',
    name: 'John',
    languageKey: 'english',
    genderKey: 'male',
    sampleUrl: '/assets/voices/voice_john.m4a',
  },
];
